module.exports = __webpack_public_path__ + "img/PaySuccessEN.41568567.png";